export default __webpack_public_path__ + "4b37da5a2d72e35e6737c63a2d2cd6a0.png";